import { addDisplayName, addProps, flowMax } from 'ad-hok'
import { FC } from 'react'
import { createUseStyles } from 'react-jss'
import { formattedStat } from 'shared/src/utils/formatting'
import cx from 'classnames'

import { SANS_SERIF_FONT_FAMILY } from './styles'
import viewsIcon from '../assets/views-icon.svg'

const useStyles = createUseStyles({
  viewsContainer: {
    display: 'flex',
    flexDirection: 'row',
    fontSize: 14,
    fontFamily: SANS_SERIF_FONT_FAMILY,
  },
  viewsIcon: {
    paddingTop: 2,
  },
  views: {
    color: '#ffffff',
    marginLeft: 2,
  },
})

interface Props {
  views: number
  className?: string
}

export const ProductViews: FC<Props> = flowMax(
  addDisplayName('ProductViews'),
  addProps(({ views }) => ({
    formattedViews: formattedStat(views),
  })),
  addProps(() => ({
    classes: useStyles(),
  })),
  ({ formattedViews, classes, className }) => (
    <div className={cx(classes.viewsContainer, className)}>
      <img src={viewsIcon} alt="" className={classes.viewsIcon} />
      <p className={classes.views}>{formattedViews}</p>
    </div>
  )
)
